import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Device } from 'models/Device/type';

export interface DeviceState {
  device: Device | undefined;
  fetched: boolean;
}

const initialState: DeviceState = {
  device: undefined,
  fetched: false,
};

const slice = createSlice({
  name: 'device',
  initialState,
  reducers: {
    setDevice: (state, action: PayloadAction<Device>): DeviceState => {
      return {
        ...state,
        device: action.payload,
      };
    },
    fetched: (state): DeviceState => {
      return {
        ...state,
        fetched: true,
      };
    },
    saveEmail: (state, action: PayloadAction<string>): DeviceState => {
      return {
        ...state,
        device: {
          ...state.device,
          email: action.payload,
        },
      };
    },
    clearEmail: (state): DeviceState => {
      return {
        ...state,
        device: {
          ...state.device,
          email: undefined,
        },
      };
    },
    logout: (state): DeviceState => {
      return {
        ...state,
        device: {
          ...state.device,
          user: undefined,
        },
      };
    },
    reInstall: (state): DeviceState => {
      return {
        ...state,
        device: {
          ...state.device,
          uid: undefined,
          detail: undefined,
          reInstall: true,
        },
      };
    },
  },
});

export const deviceReducer = slice.reducer;
export const {
  setDevice,
  fetched,
  saveEmail,
  clearEmail,
  logout,
  reInstall,
} = slice.actions;
